import { Grid2 } from "@mui/material";
import { DateTime } from "luxon";
import { BookingScheduleInterface } from "../../../../features/Booking-Form/typings/booking.types";
import InputDialogSchedule from "../../../Dialog/partials/input-dialog-schedule.component";
import InputDialogScheduleConferenceDetails from "../../../Dialog/partials/input-dialog-schedule-conference-details.component";
import { BookingType } from "../../../../features/Booking-Form/typings/booking-inputs";

type P = {
  isMobileTablet: boolean;
  isEditable: boolean;
  isColleagueScheduleEditable: boolean;
  schedule: BookingScheduleInterface;
  refetchAllSchedule?: () => void;
};

export const ScheduleSelectionInviteVisitorsTab: React.FC<P> = ({
  isMobileTablet,
  isEditable,
  isColleagueScheduleEditable,
  schedule,
  refetchAllSchedule
}) => {
  const isFullyPastSchedule =
    DateTime.fromISO(schedule.endDate).valueOf() < DateTime.now().valueOf();
  /** Colleague-admin (#1577) may edit guests when fully past; own/colleague blocked only when end < now. */
  const canEditSchedule =
    (isEditable || isColleagueScheduleEditable) &&
    !schedule.isGuest &&
    (isColleagueScheduleEditable || !isFullyPastSchedule);
  const inputDisabled = !canEditSchedule;

  return (
    <Grid2
      container
      data-testid="booking-selection-tabPanel-1-inviteAndVisitors"
      rowGap={isMobileTablet ? 2 : 5}
      sx={[
        isMobileTablet ? { width: "99%" } : { width: "31vw" },
        isMobileTablet ? { mt: 0 } : { mt: 2 }
      ]}
    >
      <InputDialogSchedule
        schedule={schedule}
        appointmentDataId={{ id: schedule.id }}
        selectedUserBookedFor={schedule.userBookedFor}
        mode={schedule.bookingType !== BookingType.CONFERENCEZONE}
        disabled={inputDisabled}
        refetchAllSchedule={refetchAllSchedule}
      />

      <InputDialogScheduleConferenceDetails
        scheduleData={schedule}
        appointmentDataId={{ id: schedule.id }}
        disabled={inputDisabled}
        refetchAllSchedule={refetchAllSchedule}
      />
    </Grid2>
  );
};
